var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"copyright"},[_vm._v(" © Copyright 2021 PagerDuty, Inc. All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }